import React from 'react'
import deepSpaImg from "./../../../../Images/SpaInnerPage/Deep Tissue Massage.png";

const DeepSpaImg = () => {
  return (
    <div className="headSpaImgContainer">
      <img src={deepSpaImg} alt="deepSpaImg" />
    </div>
  )
}

export default DeepSpaImg
